import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
const MIDDLEWARE_URL = process.env.REACT_APP_API_URL;


const getCookie = (name) => {
  const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
  return match ? decodeURIComponent(match[2]) : null;
};

const ROLE_CONFIG = {
  super_admin: { label: "Super Admin", color: "#7C3AED", bg: "#F5F3FF", icon: "◆", dashboard: "/superadmin" },
  admin:       { label: "Administrateur", color: "#6c63ff", bg: "#f0efff", icon: "▸", dashboard: "/admin" },
  user:        { label: "Utilisateur",    color: "#64748B", bg: "#F8FAFC", icon: "○", dashboard: "/home" },
};

export default function ProfileUser() {
  const navigate = useNavigate();

  const [profile, setProfile] = useState({ name: "", email: "", tel: "" });
  const [societeReelNom, setSocieteReelNom] = useState("");
  const [saving,  setSaving]  = useState(false);
  const [toast,   setToast]   = useState(null);

  const sid        = getCookie("societe_id");
  const role       = getCookie("role") || "user";
  const roleCfg    = ROLE_CONFIG[role] || ROLE_CONFIG.user;
  const societeNom = role === "admin" || role === "super_admin"
  ? "LOGIMES"
  : (getCookie("societe") || getCookie("societe_folder") || "LOGIMES");

  // ── Navigation intelligente selon rôle ──
  const goBack = () => navigate(roleCfg.dashboard);

  useEffect(() => {
    const name  = getCookie("name")  || "";
    const email = getCookie("email") || "";
    const tel   = localStorage.getItem(`tel_${sid}`) || "";
    setProfile({ name, email, tel });
  }, []);

  const showToast = (msg, type = "success") => {
    setToast({ msg, type });
    setTimeout(() => setToast(null), 3500);
  };

  const handleSave = async () => {
    setSaving(true);
    localStorage.setItem(`tel_${sid}`, profile.tel);
    // Met à jour le cookie name si changé
    if (profile.name) {
      document.cookie = `name=${encodeURIComponent(profile.name)};path=/`;
    }
    await new Promise(r => setTimeout(r, 600));
    setSaving(false);
    showToast(" Profil sauvegardé !");
  };

  const handleLogout = () => {
    ["token","role","name","email","societe_id","societe_folder","societe"].forEach(k =>
      document.cookie = `${k}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`
    );
    navigate("/");
  };

  const initials = profile.name
    ? profile.name.split(" ").map(n => n[0]).join("").toUpperCase().slice(0, 2)
    : "U";

  // ─────────────────────────────────────────────
  // RENDER
  // ─────────────────────────────────────────────
  return (
    <div style={S.root}>
      <style>{css}</style>

      {/* ══ SIDEBAR ══ */}
      <aside style={S.sidebar}>
        <div style={S.brand} onClick={goBack}>
          <div style={S.brandMark}>⚡</div>
          <span style={S.brandName}>LOGIMES</span>
        </div>

        <nav style={S.sidebarNav}>

          {/* Dashboard link selon rôle */}
          <div style={S.navItem} className="nav-hover" onClick={goBack}>
            <span style={S.navIcon}>🏠</span>
            <span style={S.navLabel}>
              {role === "admin" ? "Admin Dashboard" : role === "super_admin" ? "Super Admin" : "Accueil"}
            </span>
          </div>

          {/* Links selon rôle */}
          {role === "user" && (
            <>
              <div style={S.navItem} className="nav-hover" onClick={() => navigate("/home")}>
                <span style={S.navIcon}>🧾</span>
                <span style={S.navLabel}>Mes Factures</span>
              </div>
              <div style={S.navItem} className="nav-hover" onClick={() => navigate("/home")}>
                <span style={S.navIcon}>📡</span>
                <span style={S.navLabel}>Dashboard</span>
              </div>
            </>
          )}

          {role === "admin" && (
            <>
              <div style={S.navItem} className="nav-hover" onClick={() => navigate("/admin")}>
                <span style={S.navIcon}>👥</span>
                <span style={S.navLabel}>Users Société</span>
              </div>
              <div style={S.navItem} className="nav-hover" onClick={() => navigate("/admin")}>
                <span style={S.navIcon}>🏢</span>
                <span style={S.navLabel}>Sociétés</span>
              </div>
              <div style={S.navItem} className="nav-hover" onClick={() => navigate("/home")}>
                <span style={S.navIcon}>🧾</span>
                <span style={S.navLabel}>Gérer Factures</span>
              </div>
            </>
          )}

          {role === "super_admin" && (
            <>
              <div style={S.navItem} className="nav-hover" onClick={() => navigate("/superadmin")}>
                <span style={S.navIcon}>👥</span>
                <span style={S.navLabel}>Gestion Users</span>
              </div>
              <div style={S.navItem} className="nav-hover" onClick={() => navigate("/superadmin")}>
                <span style={S.navIcon}>🏢</span>
                <span style={S.navLabel}>Sociétés CRUD</span>
              </div>
            </>
          )}

          {/* Paramètres */}
          <div style={{ ...S.sectionLabel, color: "#9b59b6" }}>
            <span style={{ ...S.sectionDot, background: "#9b59b6" }} />
            Paramètres
          </div>

          <div style={{ ...S.navItem, background: "#9b59b618", color: "#9b59b6", borderLeft: "3px solid #9b59b6" }}>
            <span style={S.navIcon}>👤</span>
            <span style={S.navLabel}>Mon Profil</span>
          </div>
        </nav>

        <div style={S.sidebarFooter}>
          <div style={S.userCard}>
            <div style={{ ...S.userInitials, background: roleCfg.color }}>{initials}</div>
            <div style={S.userMeta}>
              <div style={S.userNameText}>{profile.name || "Utilisateur"}</div>
              <div style={{ fontSize:"0.63rem", color: roleCfg.color, fontWeight:600 }}>
                {roleCfg.icon} {roleCfg.label}
              </div>
            </div>
          </div>
          <button style={S.logoutBtn} className="logout-hover" onClick={handleLogout}>
            🚪 Déconnexion
          </button>
        </div>
      </aside>

      {/* ══ MAIN ══ */}
      <main style={S.main}>

        {/* Header */}
        <header style={S.header}>
          <div>
            <div style={S.headerEyebrow}>
              {role === "admin" ? "Administration" : role === "super_admin" ? "God Mode" : "Espace Utilisateur"} · {societeNom}
            </div>
            <h1 style={S.headerTitle}>Mon Profil</h1>
          </div>
          <button style={S.btnBack} onClick={goBack}>
            ← Retour au dashboard
          </button>
        </header>

        {/* Content */}
        <div style={S.content}>

          {/* ── Avatar Card ── */}
          <div style={S.avatarCard}>
            <div style={{ ...S.avatarCircle, background: `linear-gradient(135deg, ${roleCfg.color}, ${roleCfg.color}aa)` }}>
              {initials}
            </div>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: "1.4rem", fontWeight: 800, color: "#1a1a2e" }}>
                {profile.name || "Utilisateur"}
              </div>
              <div style={{ fontSize: "0.85rem", color: "#94A3B8", marginTop: 4 }}>
                {profile.email || "—"}
              </div>
              <div style={{ marginTop: 10, display: "flex", gap: 8, flexWrap: "wrap" }}>
                <span style={{ background: roleCfg.bg, color: roleCfg.color, border: `1px solid ${roleCfg.color}40`, borderRadius: 20, padding: "3px 12px", fontSize: "0.72rem", fontWeight: 700 }}>
                  {roleCfg.icon} {roleCfg.label}
                </span>
                <span style={{ background: "#F8FAFC", color: "#64748B", border: "1px solid #E2E8F0", borderRadius: 20, padding: "3px 12px", fontSize: "0.72rem", fontWeight: 600 }}>
                  🏢 {societeNom}
                </span>
                <span style={{ background: "#f0fdf4", color: "#16a34a", border: "1px solid #bbf7d0", borderRadius: 20, padding: "3px 12px", fontSize: "0.72rem", fontWeight: 600 }}>
                  ✅ Actif
                </span>
              </div>
            </div>
          </div>

          {/* ── Infos personnelles ── */}
          <div style={S.card}>
            <div style={S.cardTitle}>✏️ Informations personnelles</div>

            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16, marginBottom: 16 }}>
              <div style={S.formGroup}>
                <label style={S.formLabel}>Nom complet</label>
                <input style={S.input} value={profile.name}
                  onChange={e => setProfile({ ...profile, name: e.target.value })}
                  placeholder="Votre nom complet" />
              </div>
              <div style={S.formGroup}>
                <label style={S.formLabel}>Téléphone</label>
                <input style={S.input} value={profile.tel}
                  onChange={e => setProfile({ ...profile, tel: e.target.value })}
                  placeholder="+216 xx xxx xxx" />
              </div>
            </div>

            <div style={S.formGroup}>
              <label style={S.formLabel}>
                Email{" "}
                <span style={{ color: "#94A3B8", fontWeight: 400, fontSize: "0.75rem", textTransform: "none" }}>
                  (non modifiable)
                </span>
              </label>
              <input
                style={{ ...S.input, background: "#F8FAFC", color: "#94A3B8", cursor: "not-allowed" }}
                value={profile.email} disabled />
            </div>

            <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, marginTop: 8 }}>
              <button style={S.btnCancel} onClick={goBack}>Annuler</button>
              <button style={{ ...S.btnSave, background: `linear-gradient(135deg, ${roleCfg.color}, ${roleCfg.color}cc)` }}
                onClick={handleSave} disabled={saving}>
                {saving ? "⏳ Sauvegarde..." : "💾 Sauvegarder"}
              </button>
            </div>
          </div>

          {/* ── Sécurité ── */}
          <div style={S.card}>
            <div style={S.cardTitle}>🔐 Sécurité</div>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "12px 0" }}>
              <div>
                <div style={{ fontWeight: 700, fontSize: "0.92rem", color: "#1a1a2e", marginBottom: 4 }}>
                  Mot de passe
                </div>
                <div style={{ fontSize: "0.8rem", color: "#94A3B8" }}>
                  Modifier votre mot de passe de connexion
                </div>
              </div>
              <button style={S.btnSecurity} onClick={() => navigate("/forgot-password")}>
                Changer →
              </button>
            </div>
          </div>

          {/* ── Infos compte ── */}
          <div style={S.card}>
            <div style={S.cardTitle}>🏢 Informations du compte</div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
              {[
                ["Société",       societeNom],
                ["Identifiant",   `ID-${sid || "—"}`],
                ["Rôle",          roleCfg.label],
                ["Statut",        "✅ Actif"],
                ["Dashboard",     roleCfg.dashboard],
              ].map(([k, v]) => (
                <div key={k} style={S.infoRow}>
                  <div style={S.infoKey}>{k}</div>
                  <div style={{ ...S.infoVal, color: k === "Rôle" ? roleCfg.color : "#0F172A" }}>{v}</div>
                </div>
              ))}
            </div>
          </div>

          {/* ── Actions rapides ── */}
          <div style={S.card}>
            <div style={S.cardTitle}>⚡ Actions rapides</div>
            <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
              <button style={{ ...S.actionBtn, borderColor: roleCfg.color + "50", color: roleCfg.color, background: roleCfg.bg }}
                onClick={goBack}>
                🏠 {role === "admin" ? "Admin Dashboard" : role === "super_admin" ? "Super Admin" : "Tableau de bord"}
              </button>
              {role !== "super_admin" && (
                <button style={S.actionBtn} onClick={() => navigate("/home")}>
                  🧾 Gérer les factures
                </button>
              )}
              <button style={{ ...S.actionBtn, color: "#dc2626", borderColor: "#fecaca", background: "#fff0f0" }}
                onClick={handleLogout}>
                🚪 Déconnexion
              </button>
            </div>
          </div>

        </div>
      </main>

      {/* ══ TOAST ══ */}
      {toast && (
        <div style={{ ...S.toast, ...(toast.type === "error" ? S.toastErr : S.toastOk) }} className="toast-in">
          <span style={S.toastDot} />
          {toast.msg}
        </div>
      )}
    </div>
  );
}

// ─────────────────────────────────────────────
// STYLES
// ─────────────────────────────────────────────
const S = {
  root:          { display:"flex", minHeight:"100vh", background:"#F8FAFC", fontFamily:"'Outfit','Segoe UI',sans-serif", color:"#0F172A" },
  sidebar:       { width:224, flexShrink:0, background:"#fff", borderRight:"1.5px solid #ededf5", display:"flex", flexDirection:"column", position:"fixed", top:0, left:0, bottom:0, zIndex:100, boxShadow:"4px 0 20px rgba(108,99,255,0.06)" },
  brand:         { display:"flex", alignItems:"center", gap:10, padding:"20px 16px 12px", cursor:"pointer", borderBottom:"1px solid #F1F5F9" },
  brandMark:     { width:34, height:34, background:"#6c63ff", borderRadius:9, display:"flex", alignItems:"center", justifyContent:"center", fontSize:"1.1rem", color:"#fff", flexShrink:0 },
  brandName:     { fontSize:"1.05rem", fontWeight:800, color:"#6c63ff" },
  sidebarNav:    { flex:1, overflowY:"auto", padding:"8px" },
  sectionLabel:  { display:"flex", alignItems:"center", gap:6, fontSize:"0.63rem", fontWeight:700, letterSpacing:"0.08em", textTransform:"uppercase", padding:"10px 8px 3px" },
  sectionDot:    { width:5, height:5, borderRadius:"50%", flexShrink:0 },
  navItem:       { display:"flex", alignItems:"center", gap:10, padding:"8px 10px", borderRadius:8, cursor:"pointer", transition:"all 0.15s", marginBottom:1, fontSize:"0.84rem", fontWeight:500, color:"#64748b", borderLeft:"3px solid transparent" },
  navIcon:       { fontSize:"0.95rem", width:20, textAlign:"center", flexShrink:0 },
  navLabel:      { overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" },
  sidebarFooter: { borderTop:"1.5px solid #ededf5", padding:"10px" },
  userCard:      { display:"flex", alignItems:"center", gap:8, padding:"8px 10px", borderRadius:10, background:"#F8FAFC", marginBottom:6 },
  userInitials:  { width:30, height:30, borderRadius:"50%", color:"#fff", display:"flex", alignItems:"center", justifyContent:"center", fontSize:"0.82rem", fontWeight:700, flexShrink:0 },
  userMeta:      { overflow:"hidden" },
  userNameText:  { fontSize:"0.8rem", fontWeight:600, color:"#1a1a2e", whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis" },
  logoutBtn:     { display:"flex", alignItems:"center", gap:6, width:"100%", padding:"7px 10px", borderRadius:8, border:"none", background:"#fff0f0", cursor:"pointer", fontSize:"0.78rem", fontWeight:600, color:"#dc2626", fontFamily:"inherit", transition:"all 0.15s" },
  main:          { flex:1, marginLeft:224, display:"flex", flexDirection:"column", minHeight:"100vh" },
  header:        { display:"flex", alignItems:"center", justifyContent:"space-between", padding:"16px 32px", background:"#fff", borderBottom:"1.5px solid #ededf5", position:"sticky", top:0, zIndex:50, boxShadow:"0 2px 12px rgba(108,99,255,0.05)" },
  headerEyebrow: { fontSize:"0.68rem", fontWeight:600, letterSpacing:"0.08em", color:"#94A3B8", textTransform:"uppercase", marginBottom:3 },
  headerTitle:   { fontSize:"1.2rem", fontWeight:800, color:"#1a1a2e" },
  btnBack:       { display:"flex", alignItems:"center", gap:6, padding:"9px 18px", borderRadius:9, border:"1.5px solid #E2E8F0", background:"#fff", cursor:"pointer", fontSize:"0.82rem", fontWeight:600, color:"#334155", fontFamily:"inherit", transition:"all 0.15s" },
  content:       { padding:"28px 32px", display:"flex", flexDirection:"column", gap:20, maxWidth:900, margin:"0 auto", width:"100%" },
  avatarCard:    { background:"#fff", borderRadius:16, border:"1.5px solid #e8e8f0", padding:"28px 32px", display:"flex", alignItems:"center", gap:24 },
  avatarCircle:  { width:80, height:80, borderRadius:"50%", display:"flex", alignItems:"center", justifyContent:"center", fontSize:"1.8rem", fontWeight:800, color:"#fff", flexShrink:0, boxShadow:"0 8px 24px rgba(108,99,255,0.25)" },
  card:          { background:"#fff", borderRadius:14, border:"1.5px solid #e8e8f0", padding:"20px 24px", display:"flex", flexDirection:"column", gap:12 },
  cardTitle:     { fontSize:"0.88rem", fontWeight:700, color:"#1a1a2e", paddingBottom:12, borderBottom:"1.5px solid #f0efff" },
  formGroup:     { display:"flex", flexDirection:"column", gap:6 },
  formLabel:     { fontSize:"0.72rem", fontWeight:700, color:"#64748B", textTransform:"uppercase", letterSpacing:"0.05em" },
  input:         { padding:"11px 14px", border:"1.5px solid #E2E8F0", borderRadius:9, fontSize:"0.88rem", color:"#0F172A", outline:"none", fontFamily:"inherit", transition:"border 0.2s", background:"#fff" },
  btnCancel:     { padding:"10px 20px", borderRadius:9, border:"1px solid #E2E8F0", background:"#fff", cursor:"pointer", fontSize:"0.84rem", fontWeight:600, color:"#64748B", fontFamily:"inherit" },
  btnSave:       { padding:"10px 24px", borderRadius:9, border:"none", color:"#fff", cursor:"pointer", fontSize:"0.84rem", fontWeight:700, fontFamily:"inherit", boxShadow:"0 4px 14px rgba(108,99,255,0.3)" },
  btnSecurity:   { padding:"9px 18px", borderRadius:9, background:"#f0efff", color:"#6c63ff", border:"1.5px solid #c7d2fe", cursor:"pointer", fontSize:"0.82rem", fontWeight:600, fontFamily:"inherit" },
  actionBtn:     { padding:"9px 18px", borderRadius:9, border:"1.5px solid #E2E8F0", background:"#fff", cursor:"pointer", fontSize:"0.82rem", fontWeight:600, color:"#334155", fontFamily:"inherit", transition:"all 0.15s" },
  infoRow:       { background:"#F8FAFC", borderRadius:9, padding:"12px 14px" },
  infoKey:       { fontSize:"0.65rem", color:"#94A3B8", fontWeight:700, textTransform:"uppercase", letterSpacing:"0.05em", marginBottom:4 },
  infoVal:       { fontSize:"0.88rem", fontWeight:700, color:"#0F172A" },
  toast:         { position:"fixed", bottom:24, right:24, display:"flex", alignItems:"center", gap:10, padding:"12px 20px", borderRadius:10, fontSize:"0.84rem", fontWeight:600, boxShadow:"0 8px 32px rgba(0,0,0,0.12)", zIndex:2000 },
  toastOk:       { background:"#0F172A", color:"#fff" },
  toastErr:      { background:"#EF4444", color:"#fff" },
  toastDot:      { width:6, height:6, borderRadius:"50%", background:"rgba(255,255,255,0.5)", flexShrink:0 },
};

const css = `
  @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700;800&display=swap');
  * { box-sizing: border-box; margin: 0; padding: 0; }
  .nav-hover:hover    { background: #f0efff !important; color: #6c63ff !important; }
  .logout-hover:hover { background: #fee2e2 !important; }
  .toast-in           { animation: toastIn 0.3s ease; }
  @keyframes toastIn  { from { opacity:0; transform:translateY(10px); } to { opacity:1; transform:translateY(0); } }
  input:focus         { border-color: #6c63ff !important; box-shadow: 0 0 0 3px rgba(108,99,255,0.1) !important; }
`;